import { TransportType } from '#/shared/api/generated/shipment/models'

import type { OrderFormDefaults } from '../ui/order-form'

const today = new Date()
const inDays = (n: number) => {
  const d = new Date(today)
  d.setDate(d.getDate() + n)
  return d
}

export const DEV_SAMPLE_DEFAULTS: OrderFormDefaults = {
  customer: {
    firstName: 'John',
    lastName: 'Doe',
    company: 'ABC Dealer',
    companyPhone: '9292342345',
    billingEmail: 'billing@example.com',
    email: `qa+${Date.now()}@example.com`,
    email2: 'alt@example.com',
    phone: '9292342345',
    mobile: '9292345678',
    note: 'Created from dev sample defaults',
  },
  vehicles: {
    vehicles: [
      {
        year: '2022',
        make: 'Toyota',
        model: 'RAV4',
        inop: false,
        type: 'suv',
        lot: '1234567',
        vin: '5N1BT3BA4PC817841',
      },
    ],
  },
  location: {
    origin: {
      businessName: 'ABC Company',
      address: '350 5th Ave',
      city: 'New York',
      state: 'NY',
      zip: '10118',
      contact: 'John Doe',
      phone: '9292342345',
      mobile: '9292345678',
      additionalNote: 'Key is hidden below the front wheel',
      type: 'business',
    },
    destination: {
      businessName: 'XYZ Logistics',
      address: '1600 Pennsylvania Ave NW',
      city: 'Washington',
      state: 'DC',
      zip: '20500',
      contact: 'Jane Smith',
      phone: '2025550143',
      mobile: '2025550144',
      additionalNote: 'Call on arrival',
      type: 'business',
    },
  },
  shipment: {
    trailer: TransportType.OPEN,
    source: '',
    tags: [],
    shipDate: inDays(2),
    pickupDate: inDays(3),
    deliveryDate: inDays(6),
    loadBoardNote: 'Sample load board note',
    customerNote: 'Sample customer note',
  },
  payment: {
    totalTariff: '1200',
    deposit: '200',
    carrierFee: '1000',
    paymentNote: 'Sample payment note',
  },
}
